/**
 * 
 *   
 */


class Logger {

  apiClient: any;

  constructor( apiClient ) {
    this.apiClient = apiClient;
  }
  

  /**
   * 
   * 
   */
  logMessage( message:string, data:any = null ) {

    if( data !== null ) {
      message += " | Additional data: " + JSON.stringify( data )
    }

    let eventJson = this.createAuditEventJson( message );

    if( !this.apiClient.firstMessageReceived ) {
      // defer sending unil server is ready?
    }

    var bundle = {
      "resourceType": "Bundle",
      "type": "batch",
      "entry": [{
        "resource": eventJson,
        "request": {
          "method": "POST",
          "url": "AuditEvent"
        }
      }]
    };

    this.apiClient.sendBundle( bundle );

    return true;
  }
  

  /**
   * 
   * @param error Error object catched in try/catch block
   */
  logErrorObject( error:any, message:string = "", data:any = null ) {

    let constructedMEssage = "Exception handled | ";
    if( message ) {
      constructedMEssage += message + " | ";
    }

    constructedMEssage += error.message;

    if( error.stack ) {
      // replace < and > with [ and ] to avoid issues with XML
      // <anonymous> is replaced with [anonymous]
      let stack = error.stack;
      stack = stack.replace( /</g, "[" );
      stack = stack.replace( />/g, "]" );
      constructedMEssage += " | " + stack;
    }

    if( data !== null ) {
      message += " | Additional data: " + JSON.stringify( data )
    }
    
    let eventJson = this.createAuditEventJson( constructedMEssage );

    if( !this.apiClient.firstMessageReceived ) {
      // defer sending unil server is ready?
    }

    var bundle = {
      "resourceType": "Bundle",
      "type": "batch",
      "entry": [{
        "resource": eventJson,
        "request": {
          "method": "POST",
          "url": "AuditEvent"
        }
      }]
    };

    this.apiClient.sendBundle( bundle );

    return true;
  }


  /**
   * 
   * code and category from: 
   * https://dicom.nema.org/medical/dicom/current/output/chtml/part16/chapter_D.html 
   * 
   * @param message
   * @returns object
   */
  createAuditEventJson( message:string ) {

    // Create timestamp for YYYY-MM-DDThh:mm:ss.sss+zz:zz
    let ts = new Date();
    let timestamp = ts.toISOString();

    let summary = "<div xmlns=\"http://www.w3.org/1999/xhtml\">" + message +  "</div>";

    let json = {
      "resourceType" : "AuditEvent",
      "id" : "", // Keep empty to generate new id on server
      "text" : {
        "status" : "generated",
        "div" : summary
      },
      "code" : {
        "coding" : [{
          "system" : "http://dicom.nema.org/resources/ontology/DCM",
          "code" : "110100",
          "display" : "Application Activity"
        }]
      },
      "recorded" : timestamp,
      "agent" : [{
        "who" : {
          "identifier" : {
            "value" : "1"
          },
          "display" : "Placeholder"
        }
      }],
      "source" : {
        "observer" : {
          "display" : "Patient Client App"
        }
      }
    }

    return json;
  }

}


export default Logger;